import Contact from "../components/Contact/Contact";
import Navbar from "../components/Navbar/Navbar";

const ContactPage = () => {
    return (
        <div>
            <Navbar />
            <Contact />
        </div>
    )
}

export default ContactPage;
